import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { MediaPropType } from "../../../PropTypes";
import SelectMediaType from '../SelectMediaType/SelectMediaType';
import Uploader from "../Uploader/Uploader";
import { addUploader, removeUploader } from "../../../helpers/uploadsHelper";

const uploadsArray = []

function UploadMedia(props) {
  const { allowImages, allowVideo, hasMediaError, hasYouTubeError } = props;
  const [mediaType, setMediaType] = useState("none");
  let canUpload = useRef(true); //used to determine if there is an uploader with no file uploaded yet
  const [latestUploader, setLatestUploader] = useState('');

  // clear the image uploaders so that going back to photo option only has 1 uploader
  if (mediaType === "video" && uploadsArray.length) {
    uploadsArray.length = 0;
    uploadsArray.push(<Uploader key={crypto.randomUUID()} uploaderCount={uploadsArray.length+1} instanceNumber={crypto.randomUUID()} handleCallback={updateUploaderArray}/>);
  } 

  function updateUploaderArray(instanceNumber = null) {
    //if an instanceNumber is provided then remove it
    if (!removeUploader(instanceNumber, uploadsArray)) {
      canUpload.current = false;
    }
    
    //if there are not 4 uploaders then add a new one and set latestUploader to re-render the component
    if (uploadsArray.length < 4) {
      //if there is already an uploader that doesn't have an upload remove it before adding a new one
      const removeLast = instanceNumber != null && canUpload.current;
      const newInstanceNumber = addUploader(uploadsArray, removeLast, updateUploaderArray); 

      setLatestUploader(newInstanceNumber); //trigger a re-render
      canUpload.current = true;
    }
  }

  useEffect(() => {
    //add an uploader to the array and trigger a re-render
    uploadsArray.length = 0;
    const instanceNumber = crypto.randomUUID();
    uploadsArray.push(<Uploader key={crypto.randomUUID()} uploaderCount={1} instanceNumber={instanceNumber} handleCallback={updateUploaderArray} />);
    setLatestUploader(instanceNumber);
  }, [])

  return (
    <SelectMediaType
      hasMediaError={hasMediaError}
      hasYouTubeError={hasYouTubeError}
      allowImages={allowImages}
      allowVideo={allowVideo}
      mediaType={mediaType}
      setMediaType={setMediaType}
      imageUploaders={uploadsArray}/>
  );
}

UploadMedia.propTypes = {
  id: PropTypes.number,
  uploadedMedia: PropTypes.arrayOf(MediaPropType),
  externalId: PropTypes.string,
};

export default UploadMedia;
